import { Modify } from "@biblioteksentralen/types";
import { Promotion, Sommerles, SommerlesSettings } from "@libry-content/types";
import { getTemplateContentPromotionFilter } from "../promotion/utils";
import { ResolvedEventSummary, resolveEventSummaryGroqProjection, resolveRepeatedEvents } from "../events";
import groq from "groq";
import { ResolvedRecommendation, resolveRecommendationGroqProjection } from "../recommendations";
import { ResolvedListSummary, resolveListSummary } from "../lists";

export const sommerlesGroqFilter = getTemplateContentPromotionFilter("sommerles");

type SommerlesTemplateContent = Partial<SommerlesSettings> | null;

export const resolveEventsReferences = groq`events[] -> {"events": @${resolveRepeatedEvents()} | order(eventSchedule.startsAt asc) ${resolveEventSummaryGroqProjection}}.events[]`;

export const resolveSommerlesGroqProjecton = groq`
    ...,
    templateContent->,
    recommendations[]->{
      ${resolveRecommendationGroqProjection}
    },
    bookLists[]->{
      ${resolveListSummary}
    },
    "events": ${resolveEventsReferences},
    "promotion": templateContent->promotion,
  `;

export type ResolvedSommerles = Modify<
  Sommerles,
  {
    recommendations: ResolvedRecommendation[];
    bookLists: ResolvedListSummary[];
    events: ResolvedEventSummary[] | null;
    templateContent: SommerlesTemplateContent;
  } & { promotion: Promotion }
>;

export const resolveSommerlesBannerDataGroqProjection = groq`
  _id, _type, separatePage, startDate, endDate, templateContent->, "promotion": templateContent->promotion,
`;

export type ResolvedSommerlesBannerData = Pick<
  ResolvedSommerles,
  "_id" | "_type" | "separatePage" | "startDate" | "endDate" | "promotion"
> & {
  templateContent: SommerlesTemplateContent;
};
